import Vue from 'vue';
import VueMoment from 'vue-moment';
import moment from 'moment';
import serviceProvider from '@/services/service-provider';

const locale = serviceProvider.i18n.getLocale();

if (locale === 'pt') {
  /* eslint-disable global-require */
  require('moment/locale/pt-br.js');
}

Vue.use(VueMoment, {
  moment,
});
